import React, { useCallback } from 'react'
import { getGiflUrl, getThumbnailUrl } from 'utils/mux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ImgWithFallback from 'components/common/ImgWithFallback/ImgWithFallback'
import LazyImage from 'components/common/LazyImage/LazyImage'
import clsx from 'clsx'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import useStyles from './styles'

export const VideoItem = ({ src, gif, title, onClick, isLocked, isExpired, video = {}, id }) => {
    const classes = useStyles()
    const onVodClick = useCallback(() => onClick(video), [onClick, video])
    const width = 142
    const height = 84
    const playbackId = video.playbackId || null

    const finalSrc = src || getThumbnailUrl(playbackId, { width, height, time: video.thumbnailFrameTime })
    const finalGif =
        gif || getGiflUrl(playbackId, { width, height, start: video.previewGifStartTime, end: video.previewGifEndTime })
    const finalTitle = title || video.title

    return (
        <button className={classes.wrapper} onClick={onVodClick} data-testid={id} disabled={isExpired}>
            <div className={classes.imgWrapper}>
                {isLocked ? (
                    <>
                        <div className={classes.blockedImg}>
                            {isExpired ? (
                                <span>EXPIRED</span>
                            ) : (
                                <span data-testid={`${id}-is-locked`}>
                                    <FontAwesomeIcon icon={faLock} />
                                </span>
                            )}
                        </div>
                        <LazyImage src={finalSrc} thumb={finalSrc} width={width} height={height} />
                    </>
                ) : (
                    <>
                        <LazyImage
                            src={finalSrc}
                            thumb={finalSrc}
                            className="video-item-img"
                            width={width}
                            height={height}
                        />
                        <ImgWithFallback
                            src={finalGif || finalSrc}
                            className="video-item-gif"
                            width={width}
                            height={height}
                        />
                    </>
                )}
            </div>
            <div className={classes.infoWrapper}>
                <p className={clsx(classes.title, isLocked && classes.blockedTitle)}>{finalTitle}</p>
                {video.duration && <span className={classes.duration}>{video.duration}</span>}
            </div>
        </button>
    )
}

export default React.memo(VideoItem)
